export default "__VITE_ASSET__765085c9__"